module.exports = {"bewizr-misc-items":{"media":{"gallery":"图库","attachments":"附件","view":"查看媒体"},"link":{"view":"查看链接"},"embed":{"view":"查看嵌入内容"}}}